'use client'

import React from 'react';
import { VideoPlayerProvider, useVideoPlayer } from '../VideoPlayerContext';
import ReactPlayer from 'react-player';

import classes from './VideoGrid.module.scss';

const VideoPlayerRaw: React.FC<{ videoUrl: string; title: string; }> = ({ videoUrl }) => {
  const {
    data: {
      playerRef,
    },
    actions: {
      handleEnded,
    },
  } = useVideoPlayer();

  return (
    <div className={classes.videoWrapper}>
      <ReactPlayer
        ref={playerRef}
        src={videoUrl}
        style={{ position: 'absolute', top: 0, left: 0 }}
        width="100%"
        height="100%"
        controls={true}
        onReady={() => console.log(`${videoUrl} ready`)}
        onEnded={handleEnded}
      />
      <source src={videoUrl} type="video/mp4" />
    </div>
  );
};

export const VideoPlayer: React.FC<{ videoUrl: string; title: string; }> = ({ videoUrl, title }) => (
  <VideoPlayerProvider>
    <VideoPlayerRaw videoUrl={videoUrl} title={title} />
  </VideoPlayerProvider>
);

export default VideoPlayer;
